import { render, staticRenderFns } from "./WhatsappGroupFilter.vue?vue&type=template&id=d1563e60&"
import script from "./WhatsappGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./WhatsappGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports